// Shared dark popup surface used by Tooltip and Hint so the two stay visually
// identical and don't drift apart over time.

// The dark popup surface (color, ring, rounding, text). Each consumer adds its
// own padding/layout on top.
export const darkPopupSurface =
  "rounded-[10px] bg-gray-900 text-sm text-white ring-1 ring-inset ring-gray-700"

// The arrow that points from the popup to its anchor, oriented off `data-side`.
export const darkPopupArrow = [
  "size-3 rotate-45 rounded-[2px] bg-gray-900 fill-gray-900 border-gray-700",
  // top: arrow below popup, push to bottom edge, clear inline top
  "data-[side=top]:top-auto! data-[side=top]:bottom-0! data-[side=top]:translate-y-[50%]! data-[side=top]:border-b data-[side=top]:border-r",
  // bottom: arrow above popup, push to top edge, clear inline top
  "data-[side=bottom]:top-0! data-[side=bottom]:-translate-y-[50%]! data-[side=bottom]:border-t data-[side=bottom]:border-l",
  // left: arrow to the right, push to right edge, clear inline left
  "data-[side=left]:left-auto! data-[side=left]:right-0! data-[side=left]:translate-x-[50%]! data-[side=left]:border-t data-[side=left]:border-r",
  // right: arrow to the left, push to left edge, clear inline left
  "data-[side=right]:left-0! data-[side=right]:-translate-x-[50%]! data-[side=right]:border-b data-[side=right]:border-l"
].join(" ")
